export default __webpack_public_path__ + "static/media/afternoon.0c1cd77a.svg";